<script>
    import AuthCard from "../shared/AuthCard.svelte";
    import Label from "../shared/Label.svelte";
    import {translations} from "../../../stores/translations";
    import Button from "../shared/Button.svelte";
    import Input from "../shared/Input.svelte";
    import ApplicationLogo from "../shared/ApplicationLogo.svelte";
    import {AuthResource} from "../../../Api/resources/AuthResource";
    import {Navigate} from 'svelte-router-spa'
	import {theme} from "../stores/theme";
	import SSOButton from "../shared/SSOButton.svelte";
	import {enableSSO} from "../stores/settings";

    const authResource = new AuthResource();

    let credentials = {};
    let isRedirecting = false;

    function login() {
		if(isRedirecting){
			return;
		}

        isRedirecting = true;
        authResource
            .login(credentials)
            .then(() => {
                // redirect, but keep the query string and hashbang
                window.location.href = '/' + window.location.search + window.location.hash;
            }).catch((error) => {
            alert(error.response.data.message);
            isRedirecting = false;
        });
    }
</script>

<AuthCard>
    <div class="text-center text-white font-medium text-lg leading-5">
        {@html $translations.login_title}
    </div>
    <!-- Login (email or username) -->
	<form on:submit|preventDefault={login}>
		<div class="flex flex-row mt-5">
			<div class="w-1/3">
				<Label name="login" class="uppercase">{$translations.login_username}</Label>
			</div>
			<div class="w-2/3">
				<!-- svelte-ignore a11y-autofocus -->
				<Input type="text" name="login" bind:value={credentials.login} autocomplete="on"/>
			</div>
		</div>

		<!-- Password -->
		<div class="flex flex-row mt-5">
			<div class="w-1/3">
				<Label name="password" class="uppercase">{$translations.login_password}</Label>
			</div>
			<div class="w-2/3">
				<Input type="password" name="password" bind:value={credentials.password} required
					   autocomplete="current-password"/>
			</div>
		</div>

		<div class="flex flex-row mt-4">
			<div class="w-1/3"></div>
			<div class="w-2/3">
				<!-- Remember Me -->
				<div class="block">
					<Label name="remember_me" class="inline-flex items-center">
						<input id="remember_me"
							   type="checkbox"
							   class="rounded border-gray-300 text-theme-background shadow-sm focus:ring focus:ring-theme-highlight focus:ring-opacity-50"
							   name="remember"
							   bind:checked={credentials.remember}
						>
						<span class="ml-2 text-sm text-white font-roboto">{$translations.login_remember}</span>
					</Label>
				</div>

				<Button id="standard-login-button" class="mt-4 relative" type="submit" on:click={login} disabled={isRedirecting}>
					<img alt="" class="spinner w-5 h-5 absolute left-2" class:opacity-0={!isRedirecting}
						 src="{$translations.login_preloader}">
					{$translations.login_login}
				</Button>

				{#if Object.values($enableSSO).some((enabled) => enabled)}
					<div class="relative py-4">
						<div class="absolute inset-0 flex items-center">
							<div class="w-full border-t border-gray-300 opacity-50"></div>
						</div>
						<div class="relative flex justify-center text-sm">
							<span class="bg-theme-background px-2 text-white">{$translations.sso_or_continue_with}</span>
						</div>
					</div>

					{#if $enableSSO.microsoft}
						<SSOButton id="sso-microsoft-login-button" provider="microsoft" class="mt-2">
							<svg class="inline-block w-5 h-5 mr-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"></path></svg>
							<span class="mb-[1px]">{$translations.sso_continue_with_microsoft}</span>
						</SSOButton>
					{/if}

					{#if $enableSSO.google}
						<SSOButton id="sso-google-login-button" provider="google" class="mt-2">
							<svg class="inline-block w-4 h-4 mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
								<path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"></path>
							</svg>
							<span class="mb-[1px]">{$translations.sso_continue_with_google}</span>
						</SSOButton>
					{/if}
				{/if}
			</div>
		</div>
	</form>

    <div class="flex flex-row justify-between items-end mt-12">
        <a href="/">
            <ApplicationLogo class="{$theme.customerLogo ? 'w-20' : 'w-32'}"/>
        </a>

        <div class="flex items-center justify-end mt-4">
            <Navigate styles="text-sm text-white hover:text-gray-200" to="/forgot-password">
                {$translations.login_forgot}
            </Navigate>
        </div>
    </div>
</AuthCard>
